export { default } from "@features/investments/screens/dashboard-screen";
